import {GQLNow} from "gql-now";
import axios from "axios";

// Monkey-patch axios.create to increase default 10s GQLNow timeout to 120s
const originalCreate = axios.create;
axios.create = function(config) {
  if (config && config.timeout === 10000) {
    config.timeout = 120000;
  }
  return originalCreate.call(this, config);
};

const configApp = require('../config');

export function graphQLObj(type="") {
    let reqHeader = {'x-trdr-org':configApp.REACT_APP_HEADER_ORG, 'crossDomain': true };
    if(localStorage.getItem("token") && localStorage.getItem("token")!=null && localStorage.getItem("token")!="null" && localStorage.getItem("token")!="undefined"){
        reqHeader["x-access-token"] = localStorage.getItem("token");
    }

    let REACT_APP_API_URL = configApp.REACT_APP_API_URL;
    switch(type){
        case "file":
        REACT_APP_API_URL = REACT_APP_API_URL + "/trdr-file-services";
        break;
        case "email":
        REACT_APP_API_URL = REACT_APP_API_URL + "/trdr-email-services";
        break;
        case "digio":
        REACT_APP_API_URL = REACT_APP_API_URL + "/trdr-digio-services";
        break;
        default:
        REACT_APP_API_URL = REACT_APP_API_URL + "/trdr-member-services";
        break;
    }
 
    return new GQLNow(REACT_APP_API_URL, reqHeader);
}

function cleanObject(obj) {
    if (obj === null || obj === undefined) {
        return undefined;
    }
    if (Array.isArray(obj)) {
        return obj.map(cleanObject).filter(v => v !== undefined);
    }
    if (typeof obj === 'object') {
        if (Object.prototype.toString.call(obj) !== '[object Object]') {
            return obj;
        }
        const cleaned = {};
        for (const key of Object.keys(obj)) {
            const value = obj[key];
            if (value !== null && value !== undefined) {
                const cleanedVal = cleanObject(value);
                if (cleanedVal !== undefined) {
                    cleaned[key] = cleanedVal;
                }
            }
        }
        return cleaned;
    }
    return obj;
}

export async function query(operation_name, field, response_field, type=""){
    const cleanedField = cleanObject(field);
    const result = await graphQLObj(type).query(operation_name,cleanedField,response_field);
    checkTokenExpired(result);
    return result;
}

export async function mutation(operation_name, field, response_field, type=""){
    const cleanedField = cleanObject(field);
    const result = await graphQLObj(type).mutation(operation_name,cleanedField,response_field);
    checkTokenExpired(result);
    return result;
}

function checkTokenExpired(result) {
    if (result && result.errors) {
        for (const err of result.errors) {
            if (err.message === "Token expired") {
                localStorage.removeItem("token");
                window.location.href = "/";
                return;
            }
        }
    }
}